// 倒入所有接口
import apiList from './interface'

const install = Vue => {
  if (install.installed)
    return;
  install.installed = true;

  Object.defineProperties(Vue.prototype, {
    $api: {
      get() {
        return apiList
      }
    }
  })
}

export default install




// WEBPACK FOOTER //
// ./src/axiosHandler/index.js